export const USERS_TRANSLATE = {
    users: {
        breadcrumbName: "Usuarios",
        messages: {
            create: "Usuario agregado exitosamente",
            update: "Usuario actualizado exitosamente",
            delete: "Usuario desactivado exitosamente",
            recover: "Usuario restaurado exitosamente",
            activeAll: "Permisos activados exitosamente",
            inactiveAll: "Permisos desactivados exitosamente"
        },
        listActions: {
            permissions: {
                text: "Permisos"
            }
        },
        list: {
            dialog: {
                delete: {
                    title: "Desactivar usuario",
                    body: "¿Está seguro de que desea desactivar la cuenta con ID {{id}}?",
                    save: {
                        text: "Sí, desactivar"
                    },
                    back: {
                        text: "Volver"
                    },
                },
                restore: {
                    title: "Restaurar contraseña",
                    body: "Se generará una nueva contraseña aleatoria y se enviará al correo electrónico \"{{user.email}}\"",
                    actions: {
                        primary: "Restaurar",
                        secondary: "Volver"
                    }
                },
                resendEmail: {
                    title: "Reenviar correo de confirmación",
                    body: "El correo de verificación de la cuenta será reenviado a: \"{{user.email}}\"",
                    actions: {
                        primary: "Reenviar",
                        secondary: "Volver"
                    }
                }
            },
            table: {
                columns: {
                    id: "ID",
                    name: "Nombre",
                    email: "Correo electrónico"
                }
            }
        },
        create: {
            title: "Agregar usuario"
        },
        update: {
            title: "Editar usuario"
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nombre",
                        placeholder: "Ingrese el nombre"
                    },
                    email: {
                        label: "Correo electrónico",
                        placeholder: "Ingrese el correo electrónico"
                    },
                    password: {
                        label: "Contraseña",
                        placeholder: "Ingrese la contraseña"
                    },
                    passwordConfirmation: {
                        label: "Confirmar contraseña",
                        placeholder: "Ingrese la contraseña nuevamente"
                    }
                }
            }
        },
        permissions: {
            title: "Permisos",
            actions: {
                activateAll: {
                    text: "Activar todos"
                },
                inactivateAll: {
                    text: "Desactivar todos"
                },
            }
        }
    }
}
